var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fromLabel === _vm.toLabel || !_vm.toLabel)?_c('span',[_vm._v(_vm._s(_vm.fromLabel))]):_c('span',[_vm._v(_vm._s(_vm.fromLabel)+" "),_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-arrow-right-bold")]),_vm._v(" "+_vm._s(_vm.toLabel))],1)}
var staticRenderFns = []

export { render, staticRenderFns }